import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, RequireAuth } from "@/context/AuthContext";
import Masthead from "@/components/Masthead";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Category from "@/pages/Category";
import Article from "@/pages/Article";
import Galleries from "@/pages/Galleries";
import Directory from "@/pages/Directory";
import MediaKit from "@/pages/MediaKit";
import About from "@/pages/About";
import Subscribe from "@/pages/Subscribe";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import Pets from "@/pages/Pets";
import EEdition from "@/pages/EEdition";
import Classifieds from "@/pages/Classifieds";
import Contests from "@/pages/Contests";
import Marketplace from "@/pages/Marketplace";
import Events from "@/pages/Events";
import Community from "@/pages/Community";
import NassauToday from "@/pages/NassauToday";
import Interviews from "@/admin/Interviews";
import PhotoCredits from "@/pages/PhotoCredits";
import Loyalty from "@/pages/Loyalty";
import ContestDetail from "@/pages/ContestDetail";
import PromotionsAdmin from "@/admin/PromotionsAdmin";
import LoyaltyAdmin from "@/admin/LoyaltyAdmin";
import HeaderPhotosAdmin from "@/admin/HeaderPhotosAdmin";
import SponsorsAdmin from "@/admin/SponsorsAdmin";
import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/admin/AdminLayout";
import Dashboard from "@/admin/Dashboard";
import ArticlesAdmin from "@/admin/ArticlesAdmin";
import GalleriesAdmin from "@/admin/GalleriesAdmin";
import DirectoryAdmin from "@/admin/DirectoryAdmin";
import AdsAdmin from "@/admin/AdsAdmin";
import SocialAdmin from "@/admin/SocialAdmin";
import CommunityAdmin from "@/admin/CommunityAdmin";
import EventsAdmin from "@/admin/EventsAdmin";
import SubmitAdmin from "@/admin/SubmitAdmin";
import ReviewAdmin from "@/admin/ReviewAdmin";
import StaffAdmin from "@/admin/StaffAdmin";

function PublicLayout() {
  return (
    <>
      <Masthead />
      <main>
        <Outlet />
      </main>
      <Footer />
    </>
  );
}

function App() {
  useEffect(() => {
    const SITE_TITLE = "Nassau Life | Community News, Events & Marketplace";
    document.title = SITE_TITLE;
    // Re-assert in case a late-loading script overrides the title.
    const id = setInterval(() => {
      if (document.title !== SITE_TITLE) document.title = SITE_TITLE;
    }, 1000);
    const stop = setTimeout(() => clearInterval(id), 6000);
    return () => { clearInterval(id); clearTimeout(stop); };
  }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/classic" element={<Home />} />
              <Route path="/section/:slug" element={<Category />} />
              <Route path="/article/:slug" element={<Article />} />
              <Route path="/galleries" element={<Galleries />} />
              <Route path="/directory" element={<Directory />} />
              <Route path="/pets" element={<Pets />} />
              <Route path="/e-edition" element={<EEdition />} />
              <Route path="/classifieds" element={<Classifieds />} />
              <Route path="/marketplace" element={<Marketplace />} />
              <Route path="/events" element={<Events />} />
              <Route path="/community" element={<Community />} />
              <Route path="/photo-credits" element={<PhotoCredits />} />
              <Route path="/media-kit" element={<MediaKit />} />
              <Route path="/about" element={<About />} />
              <Route path="/subscribe" element={<Subscribe />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
            </Route>

            <Route path="/" element={<NassauToday />} />
            <Route path="/today" element={<NassauToday />} />
            <Route path="/loyalty" element={<Loyalty />} />
            <Route path="/contests" element={<Contests />} />
            <Route path="/contests/:id" element={<ContestDetail />} />

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<RequireAuth><AdminLayout /></RequireAuth>}>
              <Route index element={<Dashboard />} />
              <Route path="articles" element={<ArticlesAdmin />} />
              <Route path="galleries" element={<GalleriesAdmin />} />
              <Route path="interviews" element={<Interviews />} />
              <Route path="submit" element={<SubmitAdmin />} />
              <Route path="review" element={<RequireAuth adminOnly><ReviewAdmin /></RequireAuth>} />
              <Route path="events" element={<RequireAuth adminOnly><EventsAdmin /></RequireAuth>} />
              <Route path="directory" element={<RequireAuth adminOnly><DirectoryAdmin /></RequireAuth>} />
              <Route path="ads" element={<RequireAuth adminOnly><AdsAdmin /></RequireAuth>} />
              <Route path="sponsors" element={<RequireAuth adminOnly><SponsorsAdmin /></RequireAuth>} />
              <Route path="promotions" element={<RequireAuth adminOnly><PromotionsAdmin /></RequireAuth>} />
              <Route path="loyalty" element={<RequireAuth adminOnly><LoyaltyAdmin /></RequireAuth>} />
              <Route path="header-photos" element={<RequireAuth adminOnly><HeaderPhotosAdmin /></RequireAuth>} />
              <Route path="social" element={<RequireAuth adminOnly><SocialAdmin /></RequireAuth>} />
              <Route path="community" element={<RequireAuth adminOnly><CommunityAdmin /></RequireAuth>} />
              <Route path="staff" element={<RequireAuth adminOnly><StaffAdmin /></RequireAuth>} />
            </Route>
          </Routes>
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
